import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import './Navbar.css';

const Navbar = ({ transparent }) => {
    const [session, setSession] = useState(null);

    useEffect(() => {
        supabase.auth.getSession().then(({ data: { session } }) => {
            setSession(session);
        });

        const {
            data: { subscription },
        } = supabase.auth.onAuthStateChange((_event, session) => {
            setSession(session);
        });

        return () => subscription.unsubscribe();
    }, []);

    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        // Initial check
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav className={`navbar ${transparent && !isScrolled ? 'transparent' : 'solid-white'} ${isScrolled ? 'scrolled' : ''}`}>
            <div className="navbar-container">

                <div className="navbar-left">
                    <Link to="/" className="navbar-logo">
                        <img src="/logo.png" alt="The Rent Company Logo" style={{ height: '32px', marginRight: '10px' }} />
                        The Rent Company
                    </Link>
                </div>

                <div className="menu-icon" onClick={toggleMenu}>
                    <div className={isOpen ? 'bar open' : 'bar'}></div>
                    <div className={isOpen ? 'bar open' : 'bar'}></div>
                    <div className={isOpen ? 'bar open' : 'bar'}></div>
                </div>

                <div className={`navbar-links-center ${isOpen ? 'active' : ''}`}>
                    <NavLink to="/" end className="nav-link" onClick={toggleMenu}>Browse</NavLink>
                    <NavLink to="/how-it-works" className="nav-link" onClick={toggleMenu}>How It Works</NavLink>
                    <NavLink to="/about" className="nav-link" onClick={toggleMenu}>About</NavLink>
                </div>

                <div className={`navbar-right ${isOpen ? 'active' : ''}`}>
                    {session ? (
                        <>
                            <NavLink to="/my-listings" className="nav-link" onClick={toggleMenu}>My Listings</NavLink>
                            <NavLink to="/profile" className="nav-link" onClick={toggleMenu}>Profile</NavLink>
                        </>
                    ) : (
                        <div className="auth-buttons">
                            <Link to="/contact" className="nav-btn-dark" onClick={toggleMenu}>Contact Us</Link>
                        </div>
                    )}
                </div>

            </div>
        </nav>
    );
};

export default Navbar;
